"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/TeamPage/CallForwardingTab/CallForwardingSection.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);







var _phone = require('shared/services/phone');
var _Form = require('web/components/Form');
var _components = require('web/screens/Directory/TeamPage/components');









const Step = ({ icon, children, isMuted }) => (
  _react2.default.createElement('div', { className: isMuted ? 'team-page--call-flow--step team-page--muted' : 'team-page--call-flow--step', __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}
    , _react2.default.createElement('span', { 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}},  icon )
    , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 24}},  children )
  )
)

const Arrow = () => _react2.default.createElement('div', { className: "team-page--call-flow--arrow", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}, "↓")

const CallForwardingSection = ({ phoneNumber, forwardingNumber, onSave, onClear }) => {
  const [isEnabled, setIsEnabled] = _react.useState.call(void 0, !!forwardingNumber)
  const [phoneValue, setPhoneValue] = _react.useState.call(void 0, forwardingNumber || '')
  const [isSaving, setIsSaving] = _react.useState.call(void 0, false)
  const [isOpen, setIsOpen] = _react.useState.call(void 0, !!forwardingNumber)

  _react.useEffect.call(void 0, () => {
    setIsEnabled(!!forwardingNumber)
    setPhoneValue(forwardingNumber || '')
  }, [forwardingNumber])

  const parsed = _react.useMemo.call(void 0, () => _phone.parsePhoneInputValue.call(void 0, phoneValue), [phoneValue])
  const isComplete = parsed.callingCode === '1' &&
    !parsed.unsupportedExplicitCallingCode &&
    !_phone.isPhoneInputTooLong.call(void 0, phoneValue) &&
    _phone.isCompletePhoneInput.call(void 0, parsed.callingCode, parsed.nationalDigits)
  const typed = isComplete ? _phone.toE164PhoneValue.call(void 0, parsed.callingCode, parsed.nationalDigits) : ''
  const canSave = !!typed && typed !== (forwardingNumber || '')

  const toggle = async (nextEnabled) => {
    if (nextEnabled) {
      setIsEnabled(true)
      return
    }
    setIsSaving(true)
    try {
      const cleared = await onClear()
      if (cleared === false) return
      setIsEnabled(false)
      setPhoneValue('')
    } finally {
      setIsSaving(false)
    }
  }

  const save = async () => {
    setIsSaving(true)
    try {
      await onSave(phoneValue)
    } finally {
      setIsSaving(false)
    }
  }

  const cancel = () => {
    setIsEnabled(!!forwardingNumber)
    setPhoneValue(forwardingNumber || '')
    setIsOpen(false)
  }

  const teamPhone = _phone.formatPhoneNumber.call(void 0, phoneNumber) || phoneNumber
  // The preview follows what is typed once it is a whole number.
  const rings = isEnabled ? _phone.formatPhoneNumber.call(void 0, typed || forwardingNumber || '') : ''

  const preview = (
    _react2.default.createElement('div', { className: "team-page--call-flow", __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}
      , _react2.default.createElement(Step, { icon: '📱', __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}, "Family calls "  , _react2.default.createElement('strong', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 86}},  teamPhone ))
      , _react2.default.createElement(Arrow, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 87}} )
      ,  rings ? (
        _react2.default.createElement(_react2.default.Fragment, null
          , _react2.default.createElement(Step, { icon: '📞', __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}, "Rings " , _react2.default.createElement('strong', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 90}},  rings ))
          , _react2.default.createElement(Arrow, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 91}} )
          , _react2.default.createElement(Step, { icon: '📼', isMuted: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 92}}, "No answer: that phone's voicemail"    )
        )
      ) : (
        _react2.default.createElement(Step, { icon: '🔔', __self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}, "Rings in BloomText"  )
      )
    )
  )

  return (
    _react2.default.createElement(_components.TabFrame, { preview: preview, __self: this, __source: {fileName: _jsxFileName, lineNumber: 101}}
      , _react2.default.createElement('div', { className: "team-page--status-list team-page--call-forwarding" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}
        , _react2.default.createElement(_components.StatusRow, {
          icon: '📞',
          title: "Forward calls" ,
          status: forwardingNumber
            ? _react2.default.createElement(_components.StatusPill, { tone: "on", __self: this, __source: {fileName: _jsxFileName, lineNumber: 107}}, "To " ,  _phone.formatPhoneNumber.call(void 0, forwardingNumber) )
            : _react2.default.createElement(_components.StatusPill, { tone: "off", __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}}, "Off"),
          isOpen: isOpen,
          onToggle: () => isOpen ? cancel() : setIsOpen(true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}

          , _react2.default.createElement(_Form.Toggle, {
            isChecked: isEnabled,
            onChange: toggle,
            label: "Ring another US number when a family calls."       , __self: this, __source: {fileName: _jsxFileName, lineNumber: 112}}
          )
          ,  isEnabled && (
            _react2.default.createElement('div', { className: "team-page--call-forwarding--form", __self: this, __source: {fileName: _jsxFileName, lineNumber: 118}}
              , _react2.default.createElement('div', { className: "team-page--field-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 119}}, "Forward calls to"  )
              , _react2.default.createElement(_Form.PhoneInput, {
                value: phoneValue,
                onChange: setPhoneValue,
                nationalInputLabel: "Forward calls to"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 120}}
              )
              , _react2.default.createElement('p', { className: "team-page--call-forwarding--help", __self: this, __source: {fileName: _jsxFileName, lineNumber: 125}}, "Unanswered calls go to that phone's voicemail."

              )
              , _react2.default.createElement('div', { className: "team-page--form-buttons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 128}}
                , _react2.default.createElement(_Form.Button, { isDisabled: !canSave, isLoading: isSaving, onClick: save, __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}}, "Save")
                , _react2.default.createElement(_Form.Button, { isSecondary: true, onClick: cancel, __self: this, __source: {fileName: _jsxFileName, lineNumber: 130}}, "Cancel")
              )
            )
          )
        )
        , _react2.default.createElement(_components.StatusRow, {
          icon: '💬',
          title: "Texts",
          status: _react2.default.createElement('span', { className: "team-page--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 138}}, "Always arrive in BloomText"   ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 135}}
        )
      )
      ,  !forwardingNumber && (
        _react2.default.createElement('div', { className: "team-page--list-note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 142}}, "Calls to "
            ,  teamPhone , " are not forwarded. Open the row to set a number."
        )
      )
    )
  )
}

exports. default = CallForwardingSection
